import { render, staticRenderFns } from "./CreateReferralLink.vue?vue&type=template&id=70ab7ed8&scoped=true&"
import script from "./CreateReferralLink.vue?vue&type=script&lang=js&"
export * from "./CreateReferralLink.vue?vue&type=script&lang=js&"
import style0 from "./CreateReferralLink.vue?vue&type=style&index=0&id=70ab7ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab7ed8",
  null
  
)

export default component.exports